import React from 'react'
import Sidebar from "../Sidebar/Sidebar"
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";


// Component
const ProductCard = ({ logo, title, status, description }) => {
    return (
      <div className="flex items-center justify-between p-4 card-bg rounded-lg mb-3 bg-white py-4 px-6">
        <div className="flex items-center">
          <div className="w-12 h-12 mr-4">
            <img src={logo} alt={title} className="w-full h-full object-cover rounded-full" />
            </div>
          <div>
            <h3 className="text-base font-medium text-gray-800">{title}</h3>
            {description && <p className="text-xs text-gray-500">{description}</p>}

            <p className="text-xs text-gray-600 flex items-center mt-2">
  <span
    className={`h-2 w-2 rounded-full mr-2 ${
      status === 'PUBLISHED' ? 'bg-green-500' : 'bg-red-500'
    }`}
  ></span>
  {status} {status === 'UNPUBLISHED.' && 'Click Manage to see the status of your Product Page'}
</p>

          </div>
        </div>
        <Link to="/company/product-description/car-wash-software" className="border border-gray-500 text-gray-600 text-sm font-medium px-4 py-1 rounded-full hover:bg-gray-100 flex items-center justify-center">
  Manage <FiArrowRight className="ml-1 text-base" />
</Link>
      </div>
    );
  };


const Product = () => {
    const products = [
      { logo: "/Images/logo/Logo-2 1old.png", title: 'Applicant Tracking System', status: 'PUBLISHED', description: 'Recruiting Software' },
      { logo: "/Images/logo/Logo-2 1old.png", title: 'Appointment Scheduling Software', status: 'PUBLISHED', description: '' },
      { logo: "/Images/logo/Logo-2 1old.png", title: 'Blog Script', status: 'PUBLISHED', description: 'Website Builder Software' },
      { logo: "/Images/logo/Logo-2 1old.png", title: 'Cake PHP CMS Script', status: 'PUBLISHED', description: '' },
      { logo: "/Images/logo/Logo-2 1old.png", title: 'Cake PHP Facebook Login Plugin Script', status: 'UNPUBLISHED.', description: '' },
      { logo: "/Images/logo/Logo-2 1old.png", title: 'Car Wash Software', status: 'PUBLISHED', description: 'Business Management Software' },
      { logo: "/Images/logo/Logo-2 1old.png", title: 'Chat Room Script', status: 'PUBLISHED', description: 'Live Chat Software' },
    ];

    return (
<div className="bg-[#F3F2EF] mt-14 ">
    <div className="container mx-auto py-8 gap-4 sm:px-6">
    <div className="flex px-2">
                <Sidebar />
        <div className="flex-1 mx-4">
            <div className="bg-white rounded-lg py-4 px-6 mb-4">
            <div className="flex justify-between items-center">
            <h1 className="text-xl font-semibold text-gray-800">Products</h1>
            <button className="border border-blue-500 text-blue-500 text-sm font-medium px-4 py-1.5 rounded-full hover:bg-blue-50 flex items-center">
              + Add new product
            </button>
          </div>
            </div>
          
          {products.map((product, index) => (
            <ProductCard
              key={index}
              logo={product.logo}
              title={product.title}
              status={product.status}
              description={product.description}
            />
          ))}
        </div>
      </div>
      </div>
            </div>
          
    );
  };

  export default Product;